import config from '@/assets/js/config'
import {Toast} from 'vant'
export default {
    /**
     * 弹出内容
     * @param {内容} text 
     */
    show(text){
        if(config.debug) {
            console.log(text);
        } else {
            this._toast(text);
        }
    },
    error(text){
        if(config.debug) {
            console.log(text);
        } else {
            this._toast(text);
        }
    },
	_toast(text){
		var userAgent = navigator.userAgent;
		if (!/miniProgram/i.test(userAgent) || !/micromessenger/i.test(userAgent)||!window.miniImsp) {
			window.android.toast(text);
		}else{
			Toast({
			  message:text,
			  position: 'bottom',
			});
		}
	}
}
